module.exports = "<ng-http-loader [debounceDelay]=\"1000\"\n[backgroundColor]=\"'#619756'\" ></ng-http-loader>\n";